<template>
  <nav
    id="header"
    class="navbar navbar-expand-lg fixed-top"
    :class="{
      change_color_black: scrollPosition > 50,
      change_color_none: scrollPosition <= 50,
    }"
  >
    <div class="container-fluid">
      <!-- Logo Brand -->
      <div class="ps-3 py-2">
        <a class="navbar-brand me-2" href="#">
          <img
            :src="$webDomain + '/' + data.iconImageType + '/' + data.iconImage"
            alt="not found"
            width="54"
            height="48"
            class="d-inline-block"
          />
        </a>
        <span class="logo-text d-inline-block pt-2">
          Perfect Gardening Inc.</span
        >
      </div>
      <!-- Hamburger Menu Button -->
      <button
        class="navbar-toggler me-3 menu-button"
        type="button"
        data-bs-toggle="collapse"
        data-bs-target="#navbarToggler"
        aria-controls="navbarToggler"
        aria-expanded="false"
        aria-label="Toggle navigation"
      >
        <!-- Menu Button Icon -->
        <span>
          <font-awesome-icon :icon="['fas', 'bars']" />
        </span>
      </button>
      <!-- Nav Items -->
      <div
        class="collapse navbar-collapse align-items-center"
        id="navbarToggler"
      >
        <ul class="navbar-nav me-2 mt-1">
          <!-- Home Page -->
          <li class="nav-item">
            <router-link
              class="nav-link"
              to="#"
              :class="{ active: currentPage == '' }"
              @click="activePage('')"
            >
              {{ $t("homePage.header.home") }}
            </router-link>
          </li>
          <!-- About Us -->
          <li class="nav-item">
            <router-link
              class="nav-link"
              to="/#introduction"
              :class="{ active: currentPage == 'about' }"
              @click="activePage('about')"
            >
              {{ $t("homePage.header.about") }}
            </router-link>
          </li>
          <!-- Service -->
          <li class="nav-item">
            <router-link
              class="nav-link"
              to="/#service"
              :class="{ active: currentPage == 'service' }"
              @click="activePage('service')"
            >
              {{ $t("homePage.header.service") }}
            </router-link>
          </li>
          <!-- FAQ -->
          <li class="nav-item">
            <router-link
              class="nav-link"
              to="/#faq"
              :class="{ active: currentPage == 'faq' }"
              @click="activePage('faq')"
            >
              {{ $t("homePage.header.faq") }}
            </router-link>
          </li>
          <!-- Contact Us -->
          <li class="nav-item">
            <router-link
              class="nav-link"
              to="/#footer"
              :class="{ active: currentPage == 'footer' }"
              @click="activePage('footer')"
            >
              {{ $t("homePage.header.contact") }}
            </router-link>
          </li>

          <!-- Language Changing -->
          <li class="nav-item dropdown">
            <a
              class="nav-link dropdown-toggle"
              href="#"
              id="dropdownLangMenu"
              data-bs-toggle="dropdown"
              aria-expanded="false"
              >Lang (语言)
            </a>
            <ul class="dropdown-menu" aria-labelledby="dropdownLangMenu">
              <li
                v-for="locale in $i18n.availableLocales"
                :key="`locale-${locale}`"
              >
                <a class="dropdown-item langBtn" @click="changeLang(locale)">{{
                  locale === "CH" ? "中文" : "English"
                }}</a>
              </li>
            </ul>
          </li>
        </ul>
      </div>
    </div>

    <!-- Example -->
    <div class="container-fluid d-none">
      <header class="d-flex justify-content-between py-3 mb-4 border-bottom">
        <a
          href="/"
          class="d-flex align-items-center mb-3 mb-md-0 me-md-auto text-dark text-decoration-none"
        >
          <svg class="bi me-2" width="40" height="32">
            <use xlink:href="#bootstrap" />
          </svg>
          <span class="fs-4">Simple header</span>
        </a>
        <button
          class="navbar-toggler"
          type="button"
          data-bs-toggle="collapse"
          data-bs-target="#navbarSupportedContent"
          aria-controls="navbarSupportedContent"
          aria-expanded="false"
          aria-label="Toggle navigation"
        >
          <span class="navbar-toggler-icon"></span>
        </button>

        <div class="collapse navbar-collapse" id="navbarSupportedContent">
          <ul class="nav nav-pills">
            <li class="nav-item">
              <a href="#" class="nav-link active" aria-current="page">Home</a>
            </li>
            <li class="nav-item"><a href="#" class="nav-link">Features</a></li>
            <li class="nav-item"><a href="#" class="nav-link">Pricing</a></li>
            <li class="nav-item"><a href="#" class="nav-link">FAQs</a></li>
            <li class="nav-item"><a href="#" class="nav-link">About</a></li>
          </ul>
        </div>
      </header>
    </div>
  </nav>
</template>

<script>
import axios from "axios";
import { onMounted, getCurrentInstance } from "@vue/runtime-core";

export default {
  name: "Header",
  props: {
    // data: Object,
  },
  data() {
    return {
      data: "",
      currentPage: "",
      scrollPosition: null,
    };
  },
  methods: {
    activePage(pageId) {
      this.currentPage = pageId;
    },
    toggleNav() {
      document.getElementById("navbarToggler").classList.remove("show");
    },
    changeLang(lang) {
      this.$i18n.locale = lang;
    },
  },
  setup() {
    const ins = getCurrentInstance();
    // get logo image url
    const webDomain = ins.appContext.config.globalProperties.$webDomain;
    axios.get(webDomain + "/gardenInit/GardenBasic").then((response) => {
      ins.data.data = response.data.data[0];
    });

    onMounted(() => {
      // get scroll positon
      window.addEventListener("scroll", () => {
        const scrollNewPosition = document.documentElement.scrollTop;
        ins.data.scrollPosition = scrollNewPosition;
      });
    });
  },
};
</script>

<style scoped>
nav {
  padding: 0 !important;
}

.nav-link {
  font-size: 16px !important;
}

.container-fluid {
  padding-left: 0;
}

.navbar-collapse {
  justify-content: end;
  text-align: end;
}

/* Language Dropdown Menu */
.dropdown-menu {
  top: 2.5rem !important;
  left: 2.5rem !important;
  min-width: 6rem;
  text-align: center;
}

.langBtn {
  cursor: pointer;
}

/* Example */
.form-control-dark {
  color: #fff;
  background-color: var(--bs-dark);
  border-color: var(--bs-gray);
}
.form-control-dark:focus {
  color: #fff;
  background-color: var(--bs-dark);
  border-color: #fff;
  box-shadow: 0 0 0 0.25rem rgba(255, 255, 255, 0.25);
}

.bi {
  vertical-align: -0.125em;
  fill: currentColor;
}

.text-small {
  font-size: 85%;
}

.dropdown-toggle {
  outline: 0;
}
</style>
